
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'formular::schlaege',
        titel: null,
        modelname: 'Schlag',
        model: 'schlaege',
        betrieb_id: null
      },
      model: null
    }
  },
  computed: {},
  watch: {},
  methods: {
    fillModel(model = null) {
      if (!model) model = {};
      let empty = {
        name: '',
        flaeche_ha: null,
        betrieb: null,
        betrieb_id: null,
      };
      if (this.params.betrieb_id && !model.id) empty.betrieb_id = this.params.betrieb_id
      this.model = this.$fillMissing(model, empty);
    },
  },

}
